import './modules/videoPlayer';
import { Marquee3k } from './modules/marquee3000';

window.onload = () => {
    const header = document.getElementById('js-header-marquee');
    const screenWidth = window.screen.availWidth;

    if(screenWidth <= 767) {
        header.classList.add('marquee3k');
        Marquee3k.init();
        return; 
    } else {
        Marquee3k.init();
    }
}   

let currentExtraContent = null; 
const showExtraContent = (item) => {
    const extraId = item.getAttribute('data-extra-id');

    if(currentExtraContent){
        const videos = currentExtraContent.querySelectorAll('video');
        if(videos){
            videos.forEach((video) => {
                video.pause();
            });
        }
        currentExtraContent.style.display = "none";
    }         
    
    currentExtraContent = document.getElementById(extraId);
    
    if(currentExtraContent) {
        const videos = currentExtraContent.querySelectorAll('video');
        if(videos){
            videos.forEach((video) => {
                let url = video.getAttribute('data-src');
                video.src = url
                video.play();                
            });
        }
        currentExtraContent.style.display = "inline-block";
        currentExtraContent.scrollIntoView({inline: "center"});
    }
}

let currentVideo = null; 
const showVideo = (item) => {
    const videoId = item.getAttribute('data-video-id'); 

    if(currentVideo) {
        currentVideo.pause();

        // if video is already playing, set it back to null so it will pause
        if(currentVideo == document.getElementById(videoId)){
            currentVideo = null;
            return;
        }
    }         

    currentVideo = document.getElementById(videoId);
    
    if(currentVideo) {
        let url = currentVideo.getAttribute('data-src');
        currentVideo.src = url;
        currentVideo.play();
    }
}

const playAudio = (e) => {
    const audio = document.getElementById('js-audio');
    const icon = e.currentTarget.querySelector('img');

    if (audio.paused || audio.ended) {
        icon.src = '/images/pause.svg';
        audio.play();
    } else {
        icon.src = '/images/right-arrow.svg';
        audio.pause();
    }
}

const videos = document.querySelectorAll('.js-media-player');
videos.forEach((item) => {
    item.addEventListener('touchend', (e) => {
        e.preventDefault();
        showVideo(item)
    });

    item.addEventListener('click', () => showVideo(item));
});

const people = document.querySelectorAll('.js-people');
people.forEach((item) => {
    item.addEventListener('touchend', (e) => {
        e.preventDefault();
        showExtraContent(item)
    });

    item.addEventListener('click', () => showExtraContent(item));
}); 

const audioPlayer = document.getElementById('js-play');
audioPlayer.addEventListener('click', (e) => {
    playAudio(e);
})

audioPlayer.addEventListener('touchend', (e) => {
    e.preventDefault();
    playAudio(e);
})


// WEBPACK FOOTER //
// ./javascript/index.js